import { render, staticRenderFns } from "./MDSejarah.vue?vue&type=template&id=a2e5907e&scoped=true&"
import script from "./MDSejarah.vue?vue&type=script&lang=js&"
export * from "./MDSejarah.vue?vue&type=script&lang=js&"
import style0 from "./MDSejarah.vue?vue&type=style&index=0&id=a2e5907e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e5907e",
  null
  
)

export default component.exports